import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Offer } from '../types';
import { ArrowRight } from 'lucide-react';
interface BrandCardProps {
  offer: Offer;
}
export function BrandCard({
  offer
}: BrandCardProps) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/offers/${offer.id}`);
  };
  return <div onClick={handleClick} className="group bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-300 flex flex-col h-full" data-id="element-24">
      {/* Image Container */}
      <div className="relative h-40 w-full overflow-hidden bg-gray-100" data-id="element-25">
        <img src={offer.imageUrl} alt={offer.merchant} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-26" />
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-gray-700 uppercase tracking-wide shadow-sm" data-id="element-27">
          {offer.category}
        </div>
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-1" data-id="element-28">
        <div className="flex justify-between items-start mb-2" data-id="element-29">
          <h3 className="text-xl font-bold text-gray-900 group-hover:text-kithward-700 transition-colors" data-id="element-30">
            {offer.merchant}
          </h3>
        </div>

        <div className="mb-3" data-id="element-31">
          <span className="text-2xl font-bold text-green-600" data-id="element-32">
            {offer.cashbackPercent}% Cash Back
          </span>
        </div>

        <p className="text-gray-500 text-sm mb-6 line-clamp-2 flex-1" data-id="element-33">
          {offer.description}
        </p>

        <button className="w-full bg-kithward-700 text-white rounded-full py-2.5 px-4 font-bold text-sm hover:bg-kithward-800 transition-colors flex items-center justify-center gap-2 group-hover:shadow-md" data-id="element-34">
          Shop Now
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-35" />
        </button>
      </div>
    </div>;
}